import { LocationInfo } from "../models/Location.js";
import wsLocations from "../../components/Map/locations.json";

const filterLocations = (
  query: string | null,
  regionalOperationCenter: boolean
): Array<LocationInfo> => {
  let filteredLocations = wsLocations.filter(location => {
    // Default filter -- if roc not selected display all
    if (!regionalOperationCenter) {
      return true;
    }
    // ROC filter -- if roc is selected only display roc
    return location.roc === regionalOperationCenter;
  });
  if (query !== null) {
    filteredLocations = filteredLocations.filter(
      location => location.title.toUpperCase().indexOf(query.toUpperCase()) > -1
    );
  }
  return filteredLocations;
};

export default filterLocations;
